export default {"src":"/_next/static/media/ai-consulting.647ef2c0.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};